import React from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { useOrganizerShell } from '@/components/Organizer/OrganizerShell/OrganizerShellContext'
import EventHubPublishToggle from './EventHubPublishToggle'

/**
 * « Page de l'événement » publish pill above the banner, right-aligned and as wide as its content
 * (William, 29 Oct 2026: « un switch pour publier » on the hub, then « en haut à droite au-dessus de la
 * bannière et sans prendre toute la largeur »). The only place this flag is switched since the side
 * menu lost its Status block (same day): `shell.setStatus('event')` runs the publish mutation. A
 * one-line reminder of who sees the page under the label (desktop only, the pill stays short on a
 * phone). Nothing without the shell (a public visitor).
 */
export default function EventHubPublishCard() {
    const { t } = useTranslation(TranslationNS.EVENT_PAGE)
    const shell = useOrganizerShell()
    if (!shell?.status) return null
    const on = !!shell.status.event
    return (
        <div
            data-tour="hub-publish"
            className="inline-flex max-w-full items-center gap-3 rounded-[10px] border border-[#dbdadf] bg-white px-4 py-2"
        >
            <div className="min-w-0">
                <p className="m-0 text-sm font-semibold text-[#272727]">{t('Event page')}</p>
                <p className="m-0 text-[12px] leading-[1.4] text-[#5b5f6e] max-nav:hidden">
                    {on ? t('Published: visible to everyone.') : t('Not published: only you can see it.')}
                </p>
            </div>
            <EventHubPublishToggle
                checked={on}
                onChange={(state) => shell.setStatus('event', state)}
                aria-label={t('Event page')}
            />
        </div>
    )
}
